/**
 * 메인 "블로그 헤드라인" 위젯 — 최신 5건.
 */
import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { useBlogPosts } from '@/features/blog/api'
import { BLOG_CATEGORY_LABELS } from '@/lib/blog/types'
import Skeleton from '@/components/ui/Skeleton'

export default function BlogHeadlines() {
  const { data, isLoading } = useBlogPosts({ size: 5 })

  return (
    <section className="rounded-2xl border border-cb-gray-100 bg-white p-5">
      <header className="mb-3 flex items-center justify-between">
        <h2 className="text-base font-bold text-cb-gray-900">요양 블로그</h2>
        <Link
          to="/blog"
          className="flex items-center gap-0.5 text-xs font-medium text-cb-gray-500 hover:text-cb-primary"
        >
          더보기 <ChevronRight size={12} />
        </Link>
      </header>

      {isLoading ? (
        <ul className="flex flex-col gap-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <li key={i}>
              <Skeleton height="0.875rem" width="85%" />
              <Skeleton height="0.7rem" width="35%" className="mt-1" />
            </li>
          ))}
        </ul>
      ) : !data || data.content.length === 0 ? (
        <p className="py-4 text-center text-xs text-cb-gray-400">발행된 글이 없어요</p>
      ) : (
        <ul className="flex flex-col">
          {data.content.slice(0, 5).map((p) => (
            <li key={p.id} className="border-b border-cb-gray-100 last:border-0">
              <Link
                to={`/blog/${p.slug}`}
                className="flex items-start gap-2 py-2.5 hover:bg-cb-gray-50"
              >
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-cb-gray-900">
                    {p.title}
                  </p>
                  <p className="mt-0.5 text-[11px] text-cb-gray-500">
                    <span className="rounded bg-cb-primary-light px-1.5 py-0.5 text-[10px] font-semibold text-cb-primary">
                      {BLOG_CATEGORY_LABELS[p.category] ?? p.category}
                    </span>
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
